export const theme = {
  grayef: "#efefef",
  blueLight: "#6680c0",
  blueDark: "#113995",
  bgDark: "#1a161f",
  gray: "#757279",
  gradiendGray: "-webkit-linear-gradient(#eee, #333)",
};
export const userRole = {
  admin: 1,
  mod: 2,
  user: 3,
};
export const userStatus = {
  active: 1,
  ban: 2,
};
export const userProvider = {
  cinemaPlus: 1,
  google: 2,
  facebook: 3,
};
export const status = {
  approve: 1,
  pending: 2,
  reject: 3,
};
export const customScroll = {};
export const imgbbAPI =
  "https://api.imgbb.com/1/upload?key=8c6562419aad39522a13d6c6dcc52351";
